import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=1b7426c6&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7426c6",
  null
  
)

export default component.exports